<template>
	<span
		:class="props.additionalClasses"
		class="d-inline pe-1 position-relative">
		<svg
			class="info-icon icon tf-icon-10 tf-icon-sm-20"
			@click.stop="handleClick">
			<use xlink:href="#___icon___info"></use>
		</svg>

		<PackageDetalisPopUp
			:top="'0'"
			:left="'10px'"
			>
			<slot> </slot>
		</PackageDetalisPopUp>
	</span>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from "vue"

// Components
import PackageDetalisPopUp from "./packageDetalisPopUp.vue"

// Props
interface Props {
	top?: string
	left?: string
	additionalClasses?: string[]
}

const props = defineProps<Props>()

const emit = defineEmits<{
	(event: "click"): void
}>() // Strongly type the emitted event

const handleClick = (): void => {
	emit("click")
}
</script>

<style scoped>
/* Handles packageDetailsPoup showing */
.info-icon:hover + .package-info-container {
	visibility: visible;
}
</style>
